<template>
  <div>
    <b-card class="base__block">
      <div class="base__block__header">
        <p class="base__block__header-title">{{ title }}</p>
      </div>
      <ul class="base__block__category mar-top-15">
        <li
          class="base__block__category__links"
          v-for="item in list"
          :key="item.id"
        >
          <p>
            {{ item.text }}
          </p>
          <div class="base__block__edit">
            <p v-b-modal="`edit-${modal}`" @click="getDataItem(item)">
              Редактировать
            </p>
            <p
              class="color-red mar-left-15"
              v-b-modal.delete
              @click="getDataForRemove(item.id, `${modal.slice(0, -1)}ies`)"
            >
              Удалить
            </p>
          </div>
        </li>
      </ul>
      <b-button
        pill
        class="btn-lg btn-theme-inverse mar-bot-15 mar-top-15"
        v-b-modal="`new-${modal}`"
        >{{ button }}</b-button
      >
    </b-card>
  </div>
</template>
<script>
export default {
  props: ["list", "title", "button", "modal"],
  methods: {
    getDataItem(item) {
      this.$emit("getData", {
        id: item.id,
        text: item.text
      });
    },
    getDataForRemove(id, title) {
      this.$emit("removeData", {
        id: id,
        title: title
      });
    }
  }
};
</script>
